import { useSelector } from 'react-redux';
import { CircularProgress, Grid, Paper, Typography } from '@material-ui/core';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import styles from './Documents.module.css';
import { useEffect } from 'react';
import { useDocumentApi } from './hooks/useDocumentApi';
import { Breadcrumbs, Container, CssBaseline, Grow } from '@mui/material';
import { useTranslation } from 'react-i18next';
const Documents = () => {
  const userId = useSelector((state) => state.nonPersistedReducers?.userSliceReducer?.currentUser?.id);
  const { t } = useTranslation();

  const { getDocuments, downloadDocument, loading, documents } = useDocumentApi();

  useEffect(() => {
    getDocuments();
  }, [userId]);

  return (
    <Container maxWidth={false} className={styles.root}>
      <CssBaseline />
      <Breadcrumbs aria-label='breadcrumb' className={styles.breadcrumb}>
        <Typography style={{ fontFamily: 'var(--font-main)' }} variant='body1'>
          {t('documents.title')}
        </Typography>
      </Breadcrumbs>
      <Grow in={true}>
        <Container maxWidth className={styles.container}>
          <Paper className={styles.paper}>
            <Grid container item xs={12} spacing={2}>
              {documents?.map((el) => {
                return (
                  <Grid item xs={12} style={{ display: 'flex', margin: '2rem' }} key={el.id}>
                    <Typography>{t(`documents.${el.name}`)}</Typography>
                    <div
                      className={styles.documentDonwload}
                      onClick={() => {
                        downloadDocument(el.id, el.name);
                      }}>
                      {loading === el.id ? (
                        <CircularProgress style={{ marginLeft: '0.5rem' }} size={24} />
                      ) : (
                        <FileDownloadIcon />
                      )}
                    </div>
                  </Grid>
                );
              })}
            </Grid>
          </Paper>
        </Container>
      </Grow>
    </Container>
  );
};

export default Documents;
